import { ColorOptions, HtmlTagOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NPageComponentFaqComponent } from './faq.interface';

export const PAGE_COMPONENT_FAQ_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NPageComponentFaqComponent.ID,
    name: 'FAQ Component',
    tags: ['FAQ'],
    fields: [
        <NICmsContentField.IField>{
            key: 'faqsTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'FAQs Title'
        },
        <NICmsContentField.IChoiceField>{
            key: 'tag',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Force Tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: 'p'
        },
        <NICmsContentField.IChoiceField>{
            key: 'textStyle',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: 'p1'
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'textColor',
            title: 'Text Color',
            options: ColorOptions,
            colorPreview: true,
            default: 'col-1'
        },
        <NICmsContentField.IChoiceField>{
            key: 'questionTag',
            type: NICmsContentField.EFieldType.choice,
            title: 'Question Force Tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: 'h3'
        },
        <NICmsContentField.IChoiceField>{
            key: 'answerTag',
            type: NICmsContentField.EFieldType.choice,
            title: 'Answer Force Tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: 'p'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'faqs',
            title: 'FAQs Items',
            itemName: 'FAQ item',
            itemNameField: 'question',
            fields: [
                <NICmsContentField.IField>{
                    key: 'question',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Question'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'questionStyle',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Question Style',
                    options: TextStyleOptions,
                    default: 'h3-med'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'questionColor',
                    title: 'Question Color',
                    options: ColorOptions,
                    previewMode: 'color',
                    default: 'col-1'
                },
                <NICmsContentField.IField>{
                    key: 'answer',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Answer'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'answerStyle',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Answer Style',
                    options: TextStyleOptions,
                    default: 'p1'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'answerColor',
                    title: 'Answer Color',
                    options: ColorOptions,
                    previewMode: 'color',
                    default: 'col-1'
                }
            ]
        }
    ]
};
